/**
 * 콜랩 목록 목 데이터 — Discovery `Collab Spotlights` 가 쓴다.
 * @description 상태 줄이 "Crew • 2d left" · "Submitted" · "Wrapping up" · "Forming • 5d left"
 *   네 갈래를 다 밟도록 상태와 마감을 섞는다. 마감은 지금 기준 상대 시각이라 언제 열어도
 *   같은 문구가 선다.
 *
 *   이미지는 `/public` 의 것을 쓴다 — 목이 도는 동안 바깥 네트워크를 타지 않는다.
 */
import type { CollabListItem } from "@/domains/core/collab";

const MS_PER_DAY = 86_400_000;
const daysFromNow = (days: number): string =>
  new Date(Date.now() + days * MS_PER_DAY).toISOString();

const artist = (artistId: number, artistName: string) => ({
  artistId,
  artistName,
});
const category = (collabCategoryId: number, name: string) => ({
  collabCategoryId,
  name,
});

export const MOCK_COLLAB_LIST: readonly CollabListItem[] = [
  {
    collabId: 1,
    collabTitle: "Karina's Birthday Cafe",
    collabDescription: "A café near Gwanghwamun for Karina's day.",
    collabType: "CREW",
    collabStatus: "IN_PROGRESS",
    collabThumbnailUrl: ["/assets/mock/birthday-cafe.webp"],
    collabProjectDeadline: daysFromNow(2),
    artist: artist(1, "aespa"),
    collabCategories: [category(1, "Cafe event")],
    collabParticipantsCount: 12,
  },
  {
    collabId: 2,
    collabTitle: "Lyric video editing sprint",
    collabDescription: "Cut a lyric video for the new B-side in one weekend.",
    collabType: "CREW",
    collabStatus: "IN_PROGRESS",
    collabThumbnailUrl: ["/assets/mock/wall-c.jpg"],
    collabProjectDeadline: daysFromNow(2),
    artist: artist(2, "NewJeans"),
    collabCategories: [category(2, "Video")],
    collabParticipantsCount: 5,
  },
  {
    collabId: 3,
    collabTitle: "Fan art prints for the comeback",
    collabDescription: "A5 prints to hand out at the first-week fan sign.",
    collabType: "COMMUNITY",
    collabStatus: "SUBMITTED",
    collabThumbnailUrl: ["/assets/mock/wall-1.webp"],
    collabProjectDeadline: daysFromNow(9),
    artist: artist(3, "SEVENTEEN"),
    collabCategories: [category(3, "Illustration")],
    collabParticipantsCount: 8,
  },
  {
    collabId: 4,
    collabTitle: "BTS group dance cover busking",
    collabDescription: "Hongdae, Saturday evening. Bring purple.",
    collabType: "COMMUNITY",
    collabStatus: "ON_SETTLEMENT",
    collabThumbnailUrl: ["/assets/mock/wall-d.jpg"],
    collabProjectDeadline: daysFromNow(-1),
    artist: artist(4, "BTS"),
    collabCategories: [category(4, "Dance")],
    collabParticipantsCount: 20,
  },
  {
    collabId: 5,
    collabTitle: "Community Fanzine Issue #04",
    collabDescription: "Essays, comics and photos from the fandom.",
    collabType: "CREW",
    collabStatus: "RECRUITMENT",
    collabThumbnailUrl: ["/assets/mock/wall-2.png"],
    collabProjectDeadline: daysFromNow(5),
    artist: artist(5, "Stray Kids"),
    collabCategories: [category(5, "Zine")],
    collabParticipantsCount: 3,
  },
  {
    collabId: 6,
    collabTitle: "Cup sleeve event · Hongdae",
    collabDescription: "Two-day cup sleeve pop-up with a photo zone.",
    collabType: "COMMUNITY",
    collabStatus: "IN_PROGRESS",
    collabThumbnailUrl: ["/assets/mock/wall-a.jpg"],
    collabProjectDeadline: daysFromNow(11),
    artist: artist(3, "SEVENTEEN"),
    collabCategories: [category(1, "Cafe event")],
    collabParticipantsCount: 34,
  },
  {
    collabId: 7,
    collabTitle: "Photocard trade meetup",
    collabDescription: "Bring your doubles. Trade, no resale.",
    collabType: "COMMUNITY",
    collabStatus: "READY_TO_GO",
    collabThumbnailUrl: ["/assets/mock/wall-b.jpg"],
    collabProjectDeadline: daysFromNow(3),
    artist: artist(2, "NewJeans"),
    collabCategories: [category(6, "Meetup")],
    collabParticipantsCount: 15,
  },
  {
    collabId: 8,
    collabTitle: "World tour banner project",
    collabDescription: "A stadium-wide banner for the Seoul stop.",
    collabType: "CREW",
    collabStatus: "DONE",
    collabThumbnailUrl: ["/assets/mock/wall-3.webp"],
    collabProjectDeadline: daysFromNow(-20),
    artist: artist(5, "Stray Kids"),
    collabCategories: [category(7, "Banner")],
    collabParticipantsCount: 120,
  },
];
